import { actions as actions$8, uninitState, statusSuccess, idleState, useIntl, reducer as reducer$1, loadingState, failedState, successState, combineReducers, ApiConfigSelectors, IntlSelectors, useSelector, statusLoading, statusFailed, useDispatch, statusUnavailable, statusUninit, unavailableState, connect, useFeatureToggles, withIntl, LOADING, SUCCESS, ReducersRegistry, SagaRegistry } from '@grandvisionhq/state';
import { createSelector } from 'reselect';
import { Selectors, State, Types, Actions, getToken, useAccount, useMyAccountMenuItems, RouteKey, Callback, ExpiredLink, AuthContextConsumer } from '@grandvisionhq/auth';
import * as React from 'react';
import { Link, toast, Alert, MediaQuery, LoaderScreen, Loader, Delayed, Button } from '@grandvisionhq/common';
import { Text, SkeletonLoader } from '@grandvisionhq/elements';
import { Util, Form } from '@grandvisionhq/forms';
import * as swcHelpers from '@swc/helpers';
import { takeLatest, select, put, call, race, take, all } from 'redux-saga/effects';
import { Customers, Stores, Products, Orders as Orders$1 } from '@grandvisionhq/api-client';
import { format } from 'date-fns';
import { DataLayer } from '@grandvisionhq/analytics';
import { Helpers } from '@grandvisionhq/products';
import { createSlotsContext } from '@grandvisionhq/slots';
import classnames from 'classnames';
import { QueryString, StringGuard } from '@grandvisionhq/utils';
import { SubMenuLinks } from '@grandvisionhq/layout';
import { useLink } from '@grandvisionhq/frk-routing';

const FETCH_ADDRESSES = 'auth/addresses/fetch-list';
const FETCH_ADDRESSES_SUCCESS = 'auth/addresses/fetch-list-success';
const FETCH_ADDRESSES_FAILED = 'auth/addresses/fetch-list-failed';
const TOGGLE_MODAL = 'auth/adresses/toggle_modal';
const ADD_ADDRESS = 'auth/addresses/add-address';
const ADD_ADDRESS_SUCCESS = 'auth/addresses/add-address-success';
const ADD_ADDRESS_FAILED = 'auth/addresses/add-address-failed';
const EDIT_ADDRESS = 'auth/addresses/edit-address';
const EDIT_ADDRESS_SAVE = 'auth/addresses/edit-address-save';
const EDIT_ADDRESS_SUCCESS = 'auth/addresses/edit-address-success';
const EDIT_ADDRESS_FAILED = 'auth/addresses/edit-address-failed';
const DELETE_ADDRESS = 'auth/addresses/delete-address';
const DELETE_ADDRESS_CONFIRM = 'auth/addresses/add-address-confirm';
const DELETE_ADDRESS_SUCCESS = 'auth/addresses/delete-address-success';
const DELETE_ADDRESS_FAILED = 'auth/addresses/delete-address-failed';
const { action , payload  } = actions$8;
/**
 * Fetch list
 */ const fetchList$2 = action(FETCH_ADDRESSES);
const fetchListSuccess$2 = action(FETCH_ADDRESSES_SUCCESS, payload());
const fetchListFailed$2 = action(FETCH_ADDRESSES_FAILED, (error)=>({
        error
    })
);
/**
 * ToggleModal
 */ const toggleModal = action(TOGGLE_MODAL, payload());
/**
 * Add address
 */ const addAddress = action(ADD_ADDRESS, payload());
const addAddressSuccess = action(ADD_ADDRESS_SUCCESS, payload());
const addAddressFailed = action(ADD_ADDRESS_FAILED, (error)=>({
        error
    })
);
/**
 * Delete address
 */ const deleteAddress = action(DELETE_ADDRESS, payload());
const deleteAddressConfirm = action(DELETE_ADDRESS_CONFIRM);
const deleteAddressSuccess = action(DELETE_ADDRESS_SUCCESS, payload());
const deleteAddressFailed = action(DELETE_ADDRESS_FAILED, (error, id)=>({
        error,
        id
    })
);
/**
 * Edit address
 */ const editAddress = action(EDIT_ADDRESS, payload());
const editAddressSave = action(EDIT_ADDRESS_SAVE, payload());
const editAddressSuccess = action(EDIT_ADDRESS_SUCCESS, payload());
const editAddressFailed = action(EDIT_ADDRESS_FAILED, (error)=>({
        error
    })
);

var actions$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_ADDRESSES: FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS: FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILED: FETCH_ADDRESSES_FAILED,
  TOGGLE_MODAL: TOGGLE_MODAL,
  ADD_ADDRESS: ADD_ADDRESS,
  ADD_ADDRESS_SUCCESS: ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_FAILED: ADD_ADDRESS_FAILED,
  EDIT_ADDRESS: EDIT_ADDRESS,
  EDIT_ADDRESS_SAVE: EDIT_ADDRESS_SAVE,
  EDIT_ADDRESS_SUCCESS: EDIT_ADDRESS_SUCCESS,
  EDIT_ADDRESS_FAILED: EDIT_ADDRESS_FAILED,
  DELETE_ADDRESS: DELETE_ADDRESS,
  DELETE_ADDRESS_CONFIRM: DELETE_ADDRESS_CONFIRM,
  DELETE_ADDRESS_SUCCESS: DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILED: DELETE_ADDRESS_FAILED,
  fetchList: fetchList$2,
  fetchListSuccess: fetchListSuccess$2,
  fetchListFailed: fetchListFailed$2,
  toggleModal: toggleModal,
  addAddress: addAddress,
  addAddressSuccess: addAddressSuccess,
  addAddressFailed: addAddressFailed,
  deleteAddress: deleteAddress,
  deleteAddressConfirm: deleteAddressConfirm,
  deleteAddressSuccess: deleteAddressSuccess,
  deleteAddressFailed: deleteAddressFailed,
  editAddress: editAddress,
  editAddressSave: editAddressSave,
  editAddressSuccess: editAddressSuccess,
  editAddressFailed: editAddressFailed
});

const APPOINTMENTS_VIEW = 'my-account/datalayer/appointments-view';
const UPCOMING_APPOINTMENT_VIEW = 'my-account/datalayer/upcoming-appointment-view';
const RESCHEDULE_APPOINTMENT = 'my-account/datalayer/reschedule-appointment';
const appointmentsView = (appointments)=>({
        type: APPOINTMENTS_VIEW,
        payload: {
            appointments
        }
    })
;
const upcomingAppointmentView = (appointment)=>({
        type: UPCOMING_APPOINTMENT_VIEW,
        payload: {
            appointment
        }
    })
;
const rescheduleAppointment = (appointment)=>({
        type: RESCHEDULE_APPOINTMENT,
        payload: {
            appointment
        }
    })
;

var actions$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  APPOINTMENTS_VIEW: APPOINTMENTS_VIEW,
  UPCOMING_APPOINTMENT_VIEW: UPCOMING_APPOINTMENT_VIEW,
  RESCHEDULE_APPOINTMENT: RESCHEDULE_APPOINTMENT,
  appointmentsView: appointmentsView,
  upcomingAppointmentView: upcomingAppointmentView,
  rescheduleAppointment: rescheduleAppointment
});

const PAGE_VIEW = 'my-account/datalayer/page-view';
const ORDER_DETAILS_VIEW = 'my-account/datalayer/order-details-view';
const ORDER_ITEM_SELECT = 'my-account/datalayer/order-item-select';
const ORDER_REORDER = 'my-account/datalayer/order-reorder';
const TRACE_ORDER = 'my-account/datalayer/trace-order';
const PROFILE_EDIT_SUCCESS = 'my-account/datalayer/profile-edit-success';
const PROFILE_EDIT_ERROR = 'my-account/datalayer/profile-edit-error';
const PASSWORD_CHANGE_SUCCESS = 'my-account/datalayer/password-change-success';
const PASSWORD_CHANGE_ERROR = 'my-account/datalayer/password-change-error';
const pageView = (currentRoute, hideUserData)=>({
        type: PAGE_VIEW,
        payload: {
            currentRoute,
            hideUserData
        }
    })
;
const profileEditSuccess = ()=>({
        type: PROFILE_EDIT_SUCCESS
    })
;
const profileEditError = (error)=>({
        type: PROFILE_EDIT_ERROR,
        payload: {
            error
        }
    })
;
const orderDetailsView = (orderId, orderDate, paymentStatus, shippingStatus)=>({
        type: ORDER_DETAILS_VIEW,
        payload: {
            orderId,
            orderDate,
            paymentStatus,
            shippingStatus
        }
    })
;
const traceOrder = (orderId, orderDate, paymentStatus, shippingStatus)=>({
        type: TRACE_ORDER,
        payload: {
            orderId,
            orderDate,
            paymentStatus,
            shippingStatus
        }
    })
;
const orderItemSelect = (select, orderId, orderDate, paymentStatus, shippingStatus)=>({
        type: ORDER_ITEM_SELECT,
        payload: {
            select,
            orderId,
            orderDate,
            paymentStatus,
            shippingStatus
        }
    })
;
const orderReorder = (currencyCode, id, lineItems, prescriptionGlassesLineItems)=>({
        type: ORDER_REORDER,
        payload: {
            currencyCode,
            id,
            lineItems,
            prescriptionGlassesLineItems
        }
    })
;

var actions$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Appointments: actions$6,
  PAGE_VIEW: PAGE_VIEW,
  ORDER_DETAILS_VIEW: ORDER_DETAILS_VIEW,
  ORDER_ITEM_SELECT: ORDER_ITEM_SELECT,
  ORDER_REORDER: ORDER_REORDER,
  TRACE_ORDER: TRACE_ORDER,
  PROFILE_EDIT_SUCCESS: PROFILE_EDIT_SUCCESS,
  PROFILE_EDIT_ERROR: PROFILE_EDIT_ERROR,
  PASSWORD_CHANGE_SUCCESS: PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_ERROR: PASSWORD_CHANGE_ERROR,
  pageView: pageView,
  profileEditSuccess: profileEditSuccess,
  profileEditError: profileEditError,
  orderDetailsView: orderDetailsView,
  traceOrder: traceOrder,
  orderItemSelect: orderItemSelect,
  orderReorder: orderReorder
});

const FETCH_LIST$1 = 'auth/prescriptions/fetch_list';
const FETCH_LIST_SUCCESS$1 = 'auth/prescriptions/fetch_list_success';
const FETCH_LIST_FAILED$1 = 'auth/prescriptions/fetch_list_failed';
const FETCH_SIGNED = 'auth/prescriptions/fetch_signed';
const FETCH_SIGNED_SUCCESS = 'auth/prescriptions/fetch_signed_success';
const FETCH_SIGNED_FAILED = 'auth/prescriptions/fetch_signed_failed';
const fetchList$1 = ()=>({
        type: FETCH_LIST$1
    })
;
const fetchListSuccess$1 = (payload)=>({
        type: FETCH_LIST_SUCCESS$1,
        payload
    })
;
const fetchListFailed$1 = (error)=>({
        type: FETCH_LIST_FAILED$1,
        error
    })
;
const fetchSigned = ()=>({
        type: FETCH_SIGNED
    })
;
const fetchSignedSucccess = (payload)=>({
        type: FETCH_SIGNED_SUCCESS,
        payload
    })
;
const fetchSignedFailed = (error)=>({
        type: FETCH_SIGNED_FAILED,
        error
    })
;

var actions$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_LIST: FETCH_LIST$1,
  FETCH_LIST_SUCCESS: FETCH_LIST_SUCCESS$1,
  FETCH_LIST_FAILED: FETCH_LIST_FAILED$1,
  FETCH_SIGNED: FETCH_SIGNED,
  FETCH_SIGNED_SUCCESS: FETCH_SIGNED_SUCCESS,
  FETCH_SIGNED_FAILED: FETCH_SIGNED_FAILED,
  fetchList: fetchList$1,
  fetchListSuccess: fetchListSuccess$1,
  fetchListFailed: fetchListFailed$1,
  fetchSigned: fetchSigned,
  fetchSignedSucccess: fetchSignedSucccess,
  fetchSignedFailed: fetchSignedFailed
});

const SUBMIT_USER_FORM = 'my-account/submit-user-form';
const TOGGLE_FORM_EDIT_MODE = 'my-account/toggle-form-edit-mode';
const toggleFormEditMode = (payload)=>({
        type: TOGGLE_FORM_EDIT_MODE,
        payload
    })
;
const submitUserForm$1 = (payload)=>({
        type: SUBMIT_USER_FORM,
        payload
    })
;

var actions$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SUBMIT_USER_FORM: SUBMIT_USER_FORM,
  TOGGLE_FORM_EDIT_MODE: TOGGLE_FORM_EDIT_MODE,
  toggleFormEditMode: toggleFormEditMode,
  submitUserForm: submitUserForm$1
});

const FETCH_DETAIL = 'auth/subscriptions/fetch-detail';
const FETCH_DETAIL_SUCCESS = 'auth/subscriptions/fetch-detail-success';
const FETCH_DETAIL_FAILED = 'auth/subscriptions/fetch-detail-failed';
const PAUSE = 'auth/subscriptions/pause';
const PAUSE_SUCCESS = 'auth/subscriptions/pause-success';
const PAUSE_FAILED = 'auth/subscriptions/pause-failed';
const QUANTITY = 'auth/subscriptions/quantity';
const QUANTITY_SUCCESS = 'auth/subscriptions/quantity-success';
const QUANTITY_FAILED = 'auth/subscriptions/quantity-failed';
const FETCH_PRODUCT_DATA = 'auth/subscriptions/fetch-product-data';
const FETCH_PRODUCT_DATA_SUCCESS = 'auth/subscriptions/fetch-product-data-success';
const FETCH_PRODUCT_DATA_FAILED = 'auth/subscriptions/fetch-product-data-failed';
const FETCH_LIST = 'auth/subscriptions/fetch-list';
const FETCH_LIST_SUCCESS = 'auth/subscriptions/fetch-list-success';
const FETCH_LIST_FAILED = 'auth/subscriptions/fetch-list-failed';
const SUBSCRIPTION_ADDRESS_UPDATE = 'auth/subscriptions/subscription-address/update';
const SUBSCRIPTION_ADDRESS_RESET = 'auth/subscriptions/subscription-address/reset';
const SUBSCRIPTION_ADDRESS_SAVE = 'auth/subscriptions/subscription-address/save';
const SUBSCRIPTION_ADDRESS_SAVE_FAILED = 'auth/subscriptions/subscription-address/save-failed';
const SUBSCRIPTION_ADDRESS_SAVE_SUCCESS = 'auth/subscriptions/subscription-address/save-success';
const SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE = 'auth/subscriptions/subscription-address/set-is-edit-mode';
const SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN = 'auth/subscriptions/subscription-address/is-modal-open';
const fetchDetail = (payload)=>({
        type: FETCH_DETAIL,
        payload
    })
;
const fetchDetailSuccess = (payload)=>({
        type: FETCH_DETAIL_SUCCESS,
        payload
    })
;
const fetchDetailFailed = (error)=>({
        type: FETCH_DETAIL_FAILED,
        error
    })
;
const pause = (payload)=>({
        type: PAUSE,
        payload
    })
;
const pauseSuccess = (payload)=>({
        type: PAUSE_SUCCESS,
        payload
    })
;
const pauseFailed = (error)=>({
        type: PAUSE_FAILED,
        error
    })
;
const quantity = (payload)=>({
        type: QUANTITY,
        payload
    })
;
const quantitySuccess = (payload)=>({
        type: QUANTITY_SUCCESS,
        payload
    })
;
const quantityFailed = (payload)=>({
        type: QUANTITY_FAILED,
        payload
    })
;
const fetchProductData = (payload)=>({
        type: FETCH_PRODUCT_DATA,
        payload
    })
;
const fetchProductDataSuccess = (payload)=>({
        type: FETCH_PRODUCT_DATA_SUCCESS,
        payload
    })
;
const fetchProductDataFailed = (payload)=>({
        type: FETCH_PRODUCT_DATA_FAILED,
        payload
    })
;
const fetchList = ()=>({
        type: FETCH_LIST
    })
;
const fetchListSuccess = (payload)=>({
        type: FETCH_LIST_SUCCESS,
        payload
    })
;
const fetchListFailed = (error)=>({
        type: FETCH_LIST_FAILED,
        error
    })
;
const updateSubscriptionAddress = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_UPDATE,
        payload
    })
;
const resetSubscriptionAddress = ()=>({
        type: SUBSCRIPTION_ADDRESS_RESET
    })
;
const saveSubscriptionAddress = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_SAVE,
        payload
    })
;
const saveSubscriptionAddressSuccess = ()=>({
        type: SUBSCRIPTION_ADDRESS_SAVE_SUCCESS
    })
;
const saveSubscriptionAddressFailed = (error)=>({
        type: SUBSCRIPTION_ADDRESS_SAVE_FAILED,
        error
    })
;
const setSubscriptionFormIsModalOpen = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN,
        payload
    })
;
const setSubscriptionFormIsEditMode = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE,
        payload
    })
;

var actions$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_DETAIL: FETCH_DETAIL,
  FETCH_DETAIL_SUCCESS: FETCH_DETAIL_SUCCESS,
  FETCH_DETAIL_FAILED: FETCH_DETAIL_FAILED,
  PAUSE: PAUSE,
  PAUSE_SUCCESS: PAUSE_SUCCESS,
  PAUSE_FAILED: PAUSE_FAILED,
  QUANTITY: QUANTITY,
  QUANTITY_SUCCESS: QUANTITY_SUCCESS,
  QUANTITY_FAILED: QUANTITY_FAILED,
  FETCH_PRODUCT_DATA: FETCH_PRODUCT_DATA,
  FETCH_PRODUCT_DATA_SUCCESS: FETCH_PRODUCT_DATA_SUCCESS,
  FETCH_PRODUCT_DATA_FAILED: FETCH_PRODUCT_DATA_FAILED,
  FETCH_LIST: FETCH_LIST,
  FETCH_LIST_SUCCESS: FETCH_LIST_SUCCESS,
  FETCH_LIST_FAILED: FETCH_LIST_FAILED,
  SUBSCRIPTION_ADDRESS_UPDATE: SUBSCRIPTION_ADDRESS_UPDATE,
  SUBSCRIPTION_ADDRESS_RESET: SUBSCRIPTION_ADDRESS_RESET,
  SUBSCRIPTION_ADDRESS_SAVE: SUBSCRIPTION_ADDRESS_SAVE,
  SUBSCRIPTION_ADDRESS_SAVE_FAILED: SUBSCRIPTION_ADDRESS_SAVE_FAILED,
  SUBSCRIPTION_ADDRESS_SAVE_SUCCESS: SUBSCRIPTION_ADDRESS_SAVE_SUCCESS,
  SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE: SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE,
  SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN: SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN,
  fetchDetail: fetchDetail,
  fetchDetailSuccess: fetchDetailSuccess,
  fetchDetailFailed: fetchDetailFailed,
  pause: pause,
  pauseSuccess: pauseSuccess,
  pauseFailed: pauseFailed,
  quantity: quantity,
  quantitySuccess: quantitySuccess,
  quantityFailed: quantityFailed,
  fetchProductData: fetchProductData,
  fetchProductDataSuccess: fetchProductDataSuccess,
  fetchProductDataFailed: fetchProductDataFailed,
  fetchList: fetchList,
  fetchListSuccess: fetchListSuccess,
  fetchListFailed: fetchListFailed,
  updateSubscriptionAddress: updateSubscriptionAddress,
  resetSubscriptionAddress: resetSubscriptionAddress,
  saveSubscriptionAddress: saveSubscriptionAddress,
  saveSubscriptionAddressSuccess: saveSubscriptionAddressSuccess,
  saveSubscriptionAddressFailed: saveSubscriptionAddressFailed,
  setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen,
  setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode
});

/*
 * UnlinkOrder actions
 */ const unlinkOrder = actions$8.action('auth/orders/unlink', actions$8.payload());
const unlinkOrderSuccess = actions$8.action('auth/orders/unlink-success');
const unlinkOrderFailed = actions$8.action('auth/orders/unlink-failed', (error)=>({
        error
    })
);

var actions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unlinkOrder: unlinkOrder,
  unlinkOrderSuccess: unlinkOrderSuccess,
  unlinkOrderFailed: unlinkOrderFailed
});

const CHANGE_FORM_VALUE = 'my-account/change-form-value';
const CREATE_ORDER = 'my-account/create-order';
const CREATE_ORDER_SUCCESS = 'my-account/create-order-success';
const CREATE_ORDER_FAILED = 'my-account/create-order-failed';
const changeFormValue = (payload)=>({
        type: CHANGE_FORM_VALUE,
        payload
    })
;
const createOrder = (payload)=>({
        type: CREATE_ORDER,
        payload
    })
;
const createOrderSuccess = (payload)=>({
        type: CREATE_ORDER_SUCCESS,
        payload
    })
;
const createOrderFailed = (error)=>({
        type: CREATE_ORDER_FAILED,
        error
    })
;

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddressBookActions: actions$7,
  ProfileActions: actions$3,
  DataLayerActions: actions$5,
  SubscriptionsActions: actions$2,
  PrescriptionsActions: actions$4,
  UnlinkActions: actions$1,
  CHANGE_FORM_VALUE: CHANGE_FORM_VALUE,
  CREATE_ORDER: CREATE_ORDER,
  CREATE_ORDER_SUCCESS: CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILED: CREATE_ORDER_FAILED,
  changeFormValue: changeFormValue,
  createOrder: createOrder,
  createOrderSuccess: createOrderSuccess,
  createOrderFailed: createOrderFailed
});

const getMyAccount = (state)=>state.myAccount
;
const getUnlinkOrderCall = createSelector(getMyAccount, (myAccount)=>myAccount.unlinkOrderCall
);

var ViewMode;
(function(ViewMode) {
    ViewMode["ADD"] = "ADD";
    ViewMode["DELETE"] = "DELETE";
    ViewMode["EDIT"] = "EDIT";
})(ViewMode || (ViewMode = {}));

const getAddressBook = createSelector(Selectors.getAuth, getMyAccount, (auth, myAccount)=>State.isLoggedIn(auth) ? myAccount.addressBook : undefined
);
const getAddressBookList = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.list : uninitState()
);
const getAddressBookListLength = createSelector(getAddressBook, (addressBook)=>addressBook && statusSuccess(addressBook.list) ? addressBook.list.result.length : undefined
);
const getAddCall = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.calls.add : idleState()
);
const getEditCall = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.calls.edit : idleState()
);
const getModalState = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.modalState : {
        isOpen: false,
        viewMode: ViewMode.ADD
    }
);
const getEditedAddress = createSelector(getAddressBook, (addressBook)=>{
    return (addressBook === null || addressBook === void 0 ? void 0 : addressBook.currentlyEditingId) ? addressBook === null || addressBook === void 0 ? void 0 : addressBook.pendingListChanges[addressBook.currentlyEditingId] : undefined;
});

var selectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAddressBook: getAddressBook,
  getAddressBookList: getAddressBookList,
  getAddressBookListLength: getAddressBookListLength,
  getAddCall: getAddCall,
  getEditCall: getEditCall,
  getModalState: getModalState,
  getEditedAddress: getEditedAddress
});

const CancelAndReturnsModalContent = ()=>{
    const { getFormattedLabel , getLabel , hasLabel  } = useIntl();
    const phone = getLabel('account.cancelAndReturns.phone', {
        hideLabelKey: true
    });
    const email = getLabel('account.cancelAndReturns.email', {
        hideLabelKey: true
    });
    const customerServiceKey = 'account.cancelAndReturns.customerService';
    const labelValue = getLabel(customerServiceKey);
    var ref;
    // we want to avoid making multiple labels when we're adding a url, we use one label and retrieve the text and url from it so we can pass it to the Link and Text component
    const [, text, url] = (ref = /\[(.*)\]\((.*)\)/.exec(labelValue)) !== null && ref !== void 0 ? ref : [];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, getFormattedLabel('account.cancelAndReturns.description', {
        parseHTML: true
    })), hasLabel(customerServiceKey) ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "user",
        url: url
    }, text)) : null, email ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "mail",
        url: `mailto:${email}`
    }, email)) : null, phone ? /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(Link, {
        iconBefore: "phone",
        url: `tel:${phone}`
    }, phone)) : null);
};

const getProfile = createSelector(getMyAccount, Selectors.getAuth, (myAccount, auth)=>State.isLoggedIn(auth) ? myAccount.profile : undefined
);
const getForms = createSelector(getProfile, (profile)=>profile && profile.forms || {}
);
const getFormData = createSelector(getForms, (forms)=>forms ? {
        personalDetails: forms.personalDetails ? Util.getValuesFromState(forms.personalDetails.state.formState) : {},
        billingAddress: forms.billingAddress ? Util.getValuesFromState(forms.billingAddress.state.formState) : {},
        preferredStore: forms.preferredStore ? Util.getValuesFromState(forms.preferredStore.state.formState) : {}
    } : {}
);
const getPersonalDetails = createSelector(getForms, (forms)=>{
    return forms === null || forms === void 0 ? void 0 : forms.personalDetails;
});
const getBillingAddress = createSelector(getForms, (forms)=>{
    return forms === null || forms === void 0 ? void 0 : forms.billingAddress;
});
const getFormValidity = createSelector(getForms, (forms)=>({
        personalDetails: forms && forms.personalDetails ? forms.personalDetails.state.formValid : false,
        billingAddress: forms && forms.billingAddress ? forms.billingAddress.state.formValid : false,
        preferredStore: forms && forms.preferredStore ? forms.preferredStore.state.formValid : false
    })
);

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getProfile: getProfile,
  getForms: getForms,
  getFormData: getFormData,
  getPersonalDetails: getPersonalDetails,
  getBillingAddress: getBillingAddress,
  getFormValidity: getFormValidity
});

var sanitizeAddress = (_param)=>{
    var rest = swcHelpers.objectWithoutProperties(_param, [
        "addressTypes"
    ]);
    return Object.entries(rest).reduce((a, [k, v])=>v ? (a[k] = v, a) : a
    , {});
};

const sortAddresses = (list)=>list.map((address)=>swcHelpers.objectSpread({}, address, {
            createdAt: address.createdAt || '0'
        })
    ).sort((a, b)=>b.createdAt.localeCompare(a.createdAt, 'en', {
            usage: 'sort',
            numeric: true
        })
    ).sort((a, b)=>b.addressTypes.length - a.addressTypes.length
    )
;

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sanitizeAddress: sanitizeAddress,
  sortAddresses: sortAddresses
});

const initialState$4 = {
    list: uninitState(),
    pendingListChanges: {},
    calls: {
        add: idleState(),
        edit: idleState()
    },
    modalState: {
        isOpen: false,
        viewMode: ViewMode.ADD
    }
};
const getList = (list)=>statusSuccess(list) ? list.result : []
;
const pushNewAddress = (prevList, newAddress)=>{
    if (newAddress.addressTypes.length) {
        prevList = prevList.map((item)=>{
            if (item.addressTypes.length) {
                const addressTypes = item.addressTypes.filter((addressType)=>!newAddress.addressTypes.includes(addressType)
                );
                return swcHelpers.objectSpread({}, item, {
                    addressTypes
                });
            }
            return item;
        });
    }
    return sortAddresses([
        ...prevList,
        newAddress
    ]);
};
var addressBookReducer = reducer$1(initialState$4, /**
   * Fetch address book
   */ actions$8.on(fetchList$2, (state)=>swcHelpers.objectSpread({}, state, {
        list: loadingState()
    })
), actions$8.on(fetchListFailed$2, (state, action)=>swcHelpers.objectSpread({}, state, {
        list: failedState(action.error)
    })
), actions$8.on(fetchListSuccess$2, (state, action)=>swcHelpers.objectSpread({}, state, {
        list: successState(sortAddresses(action.payload))
    })
), /**
   * Toggle modal
   */ actions$8.on(toggleModal, (state, { payload  })=>swcHelpers.objectSpread({}, state, {
        modalState: swcHelpers.objectSpread({}, state.modalState, payload),
        calls: swcHelpers.objectSpread({}, initialState$4.calls)
    })
), /**
   * Add address
   */ actions$8.on(addAddress, (state)=>swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            add: loadingState()
        })
    })
), actions$8.on(addAddressFailed, (state, { error  })=>swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            add: failedState(error)
        })
    })
), actions$8.on(addAddressSuccess, (state, { payload: newAddress  })=>{
    const prevList = getList(state.list);
    const newAddresses = pushNewAddress(prevList, newAddress);
    return swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            add: idleState()
        }),
        list: successState(newAddresses),
        modalState: swcHelpers.objectSpread({}, state.modalState, {
            isOpen: false
        })
    });
}), /**
   * Delete address
   */ actions$8.on(deleteAddress, (state, { payload: id  })=>{
    const prevList = getList(state.list);
    const removedItem = prevList.find((item)=>item.id === id
    );
    return swcHelpers.objectSpread({}, state, {
        pendingListChanges: {
            [id]: removedItem
        },
        currentlyEditingId: id,
        modalState: {
            isOpen: true,
            viewMode: ViewMode.DELETE
        }
    });
}), actions$8.on(deleteAddressConfirm, (state)=>{
    const prevList = getList(state.list);
    return swcHelpers.objectSpread({}, state, {
        list: successState([
            ...prevList.filter((item)=>item.id !== state.currentlyEditingId
            )
        ]),
        currentlyEditingId: undefined,
        modalState: swcHelpers.objectSpread({}, state.modalState, {
            isOpen: false
        })
    });
}), actions$8.on(deleteAddressSuccess, (state, { payload: id  })=>{
    const _pendingListChanges = state.pendingListChanges, restPendingChanges = swcHelpers.objectWithoutProperties(_pendingListChanges, [
        id
    ].map(swcHelpers.toPropertyKey));
    return swcHelpers.objectSpread({}, state, {
        pendingListChanges: restPendingChanges
    });
}), actions$8.on(deleteAddressFailed, (state, { id  })=>{
    if (id) {
        const prevList = getList(state.list);
        const _pendingListChanges = state.pendingListChanges, { [id]: pendingItem  } = _pendingListChanges, restPendingChanges = swcHelpers.objectWithoutProperties(_pendingListChanges, [
            id
        ].map(swcHelpers.toPropertyKey));
        return swcHelpers.objectSpread({}, state, {
            list: successState(sortAddresses([
                ...prevList,
                pendingItem
            ])),
            pendingListChanges: restPendingChanges
        });
    } else {
        return swcHelpers.objectSpread({}, state, {
            modalState: swcHelpers.objectSpread({}, state.modalState, {
                isOpen: false
            })
        });
    }
}), /**
   * Edit address
   */ actions$8.on(editAddress, (state, { payload: id  })=>{
    const prevList = getList(state.list);
    const editedItem = prevList.find((item)=>item.id === id
    );
    return swcHelpers.objectSpread({}, state, {
        pendingListChanges: {
            [id]: editedItem
        },
        currentlyEditingId: id,
        modalState: {
            isOpen: true,
            viewMode: ViewMode.EDIT
        }
    });
}), actions$8.on(editAddressSave, (state)=>{
    return swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            edit: loadingState()
        })
    });
}), actions$8.on(editAddressSuccess, (state, { payload: editedFields  })=>{
    const prevList = getList(state.list).filter((item)=>item.id !== state.currentlyEditingId
    );
    const editedAddress = swcHelpers.objectSpread({}, state.pendingListChanges[state.currentlyEditingId || 0], editedFields);
    const newAddresses = pushNewAddress(prevList, editedAddress);
    return swcHelpers.objectSpread({}, state, {
        list: successState(newAddresses),
        calls: swcHelpers.objectSpread({}, state.calls, {
            edit: idleState()
        }),
        modalState: swcHelpers.objectSpread({}, state.modalState, {
            isOpen: false
        })
    });
}), actions$8.on(editAddressFailed, (state, { error  })=>{
    return swcHelpers.objectSpread({}, state, {
        calls: swcHelpers.objectSpread({}, state.calls, {
            edit: failedState(error)
        }),
        modalState: state.modalState
    });
}));

const initialState$3 = {
    listCall: idleState()
};
function prescriptionsReducer(state = initialState$3, action) {
    switch(action.type){
        case FETCH_LIST$1:
            return swcHelpers.objectSpread({}, state, {
                listCall: loadingState()
            });
        case FETCH_LIST_FAILED$1:
            return swcHelpers.objectSpread({}, state, {
                listCall: failedState(action.error)
            });
        case FETCH_LIST_SUCCESS$1:
            {
                return swcHelpers.objectSpread({}, state, {
                    listCall: idleState(),
                    list: action.payload
                });
            }
        default:
            return state;
    }
}

const isProfileForm = (formName)=>{
    if (typeof formName === 'string') {
        return formName in Types.FormName;
    }
    return formName.formName in Types.FormName;
};

const initialState$2 = {
    forms: {}
};
function profileReducer(state = initialState$2, action) {
    switch(action.type){
        case Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                forms: swcHelpers.objectSpread({}, state.forms, {
                    [action.payload.formName]: swcHelpers.objectSpread({}, state.forms[action.payload.formName], {
                        inEditMode: false
                    })
                })
            });
        case CHANGE_FORM_VALUE:
            if (!isProfileForm(action.payload.form.formName)) {
                return state;
            }
            return swcHelpers.objectSpread({}, state, {
                forms: swcHelpers.objectSpread({}, state.forms, {
                    [action.payload.form.formName]: swcHelpers.objectSpread({}, state.forms[action.payload.form.formName], {
                        state: action.payload.form
                    })
                })
            });
        case TOGGLE_FORM_EDIT_MODE:
            const initialFormState = state.forms[action.payload.formName];
            const internalState = initialFormState ? initialFormState.state : {
                formState: {},
                formValid: false,
                formName: action.payload.formName
            };
            const internalFormState = {
                state: internalState,
                inEditMode: action.payload.inEditMode
            };
            return swcHelpers.objectSpread({}, state, {
                forms: swcHelpers.objectSpread({}, state.forms, {
                    [action.payload.formName]: internalFormState
                })
            });
        default:
            return state;
    }
}

const initialState$1 = {
    detailCall: idleState(),
    pauseCall: idleState(),
    quantityCall: idleState(),
    productDataCall: idleState(),
    productData: {},
    subscriptionForm: {
        state: {},
        saveFormCall: idleState(),
        isInEditMode: false,
        isModalOpen: false
    },
    list: uninitState()
};
const getFormState = (address = {})=>{
    const { streetName , addressLine1 , addressLine2 , addressLine3 , additionalStreetInfo , additionalAddressInfo , county , region  } = address, rest = swcHelpers.objectWithoutProperties(address, [
        "streetName",
        "addressLine1",
        "addressLine2",
        "addressLine3",
        "additionalStreetInfo",
        "additionalAddressInfo",
        "county",
        "region"
    ]);
    const mappedAddress = swcHelpers.objectSpread({}, rest, {
        streetName: streetName || addressLine1 || '',
        additionalStreetInfo: additionalStreetInfo || addressLine2 || '',
        additionalAddressInfo: additionalAddressInfo || addressLine3 || '',
        region: region || county || ''
    });
    return Util.fieldsToFormState(mappedAddress);
};
function subscriptionsReducer(state = initialState$1, action) {
    switch(action.type){
        case FETCH_DETAIL:
            let detail = state.detail;
            /* Reset detail data when it's for a different subscription. We still want to re-fetch
       * the subscription because it might have been updated since the last fetch.
       * We can still display the old data until the new data is fetched though
       * so we will just replace it when the call succeeds but until then we leave the old data
       */ if (detail && detail.id !== action.payload.subscriptionId) {
                detail = undefined;
            }
            return swcHelpers.objectSpread({}, state, {
                detailCall: loadingState(),
                detail
            });
        case FETCH_DETAIL_FAILED:
            return swcHelpers.objectSpread({}, state, {
                detailCall: failedState(action.error),
                detail: undefined
            });
        case FETCH_DETAIL_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                detailCall: idleState(),
                detail: action.payload,
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    state: getFormState(action.payload.deliveryAddress)
                })
            });
        case SUBSCRIPTION_ADDRESS_UPDATE:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    state: action.payload
                })
            });
        case SUBSCRIPTION_ADDRESS_RESET:
            var ref;
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, initialState$1.subscriptionForm, {
                    state: getFormState((ref = state.detail) === null || ref === void 0 ? void 0 : ref.deliveryAddress)
                })
            });
        case SUBSCRIPTION_ADDRESS_SAVE:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    saveFormCall: loadingState()
                })
            });
        case SUBSCRIPTION_ADDRESS_SAVE_SUCCESS:
            var ref1;
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, initialState$1.subscriptionForm, {
                    state: getFormState((ref1 = state.detail) === null || ref1 === void 0 ? void 0 : ref1.deliveryAddress),
                    isModalOpen: true
                })
            });
        case SUBSCRIPTION_ADDRESS_SAVE_FAILED:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    saveFormCall: failedState(action.error)
                })
            });
        case SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    isInEditMode: action.payload
                })
            });
        case SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN:
            return swcHelpers.objectSpread({}, state, {
                subscriptionForm: swcHelpers.objectSpread({}, state.subscriptionForm, {
                    isModalOpen: action.payload
                })
            });
        case PAUSE:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: loadingState()
            });
        case PAUSE_FAILED:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: failedState(action.error)
            });
        case PAUSE_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: idleState()
            });
        case QUANTITY:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: loadingState()
            });
        case QUANTITY_FAILED:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: 'reason' in action.payload ? idleState() : failedState(action.payload)
            });
        case QUANTITY_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: idleState()
            });
        case FETCH_PRODUCT_DATA:
            return swcHelpers.objectSpread({}, state, {
                productDataCall: loadingState(),
                productData: swcHelpers.objectSpread({}, state.productData, action.payload.productIds.reduce((acc, id)=>swcHelpers.objectSpread({}, acc, {
                        [id]: loadingState()
                    })
                , {}))
            });
        case FETCH_PRODUCT_DATA_FAILED:
            const { error , productData  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                productDataCall: failedState(error),
                productData: swcHelpers.objectSpread({}, state.productData, productData)
            });
        case FETCH_PRODUCT_DATA_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                productDataCall: idleState(),
                productData: swcHelpers.objectSpread({}, state.productData, action.payload.productData)
            });
        case FETCH_LIST:
            return swcHelpers.objectSpread({}, state, {
                list: loadingState()
            });
        case FETCH_LIST_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                list: successState(action.payload)
            });
        case FETCH_LIST_FAILED:
            return swcHelpers.objectSpread({}, state, {
                list: failedState(action.error)
            });
        default:
            return state;
    }
}

const initialState = {
    profile: initialState$2,
    subscriptions: initialState$1,
    prescriptions: initialState$3,
    addressBook: initialState$4,
    unlinkOrderCall: idleState()
};
const unlinkOrderReducer = (state = initialState.unlinkOrderCall, action)=>{
    switch(action.type){
        case unlinkOrder.type:
            return loadingState();
        case unlinkOrderSuccess.type:
            return idleState();
        case unlinkOrderFailed.type:
            return failedState(action.error);
        default:
            return state;
    }
};
var reducer = combineReducers({
    profile: profileReducer,
    subscriptions: subscriptionsReducer,
    prescriptions: prescriptionsReducer,
    unlinkOrderCall: unlinkOrderReducer,
    addressBook: addressBookReducer
});

function* onFetchAddressBook() {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield put(fetchListFailed$2(new Error('User needs to be logged in to fetch addresses')));
        return;
    }
    const customerId = authState.userId;
    try {
        const accessToken = yield call(getToken);
        const result = yield call(Customers.Addresses.list, authState.apiUrl, {
            customerId,
            accessToken
        });
        yield put(fetchListSuccess$2(result));
    } catch (err) {
        yield put(fetchListFailed$2(err));
    }
}
function* onAddAddress(action) {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield put(addAddressFailed(new Error('User needs to be logged in to add an address to the address book')));
        return;
    }
    const customerId = authState.userId;
    try {
        const accessToken = yield call(getToken);
        const newAddress = yield call(Customers.Addresses.create, authState.apiUrl, {
            customerId,
            accessToken,
            address: action.payload
        });
        yield put(addAddressSuccess(newAddress));
    } catch (err) {
        yield put(addAddressFailed(err));
    }
}
function* onDeleteAddress(action) {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield call(toast.failed, 'account.addressBook.delete.authFailed');
        yield put(deleteAddressFailed(new Error('User needs to be logged in to add an address to the address book')));
        return;
    }
    const customerId = authState.userId;
    const addressId = action.payload;
    const { cancel  } = yield race({
        cancel: take(toggleModal.type),
        confirm: take(deleteAddressConfirm.type)
    });
    if (cancel) {
        return;
    }
    try {
        const accessToken = yield call(getToken);
        yield call(Customers.Addresses.deleteAddress, authState.apiUrl, {
            customerId,
            accessToken,
            addressId
        });
        yield call(toast.success, 'account.addressBook.delete.success');
        yield put(deleteAddressSuccess(addressId));
    } catch (err) {
        yield call(toast.failed, 'account.addressBook.delete.failed');
        yield put(deleteAddressFailed(err, addressId));
    }
}
function* onEditAddress(action) {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield put(editAddressFailed(new Error('User needs to be logged in to edit an address in the address book')));
        return;
    }
    const customerId = authState.userId;
    const { address: editedAddress , id  } = action.payload;
    try {
        const accessToken = yield call(getToken);
        yield call(Customers.Addresses.edit, authState.apiUrl, {
            customerId,
            accessToken,
            address: editedAddress,
            id
        });
        yield put(editAddressSuccess(editedAddress));
    } catch (err) {
        yield put(editAddressFailed(err));
    }
}
var addressBookSagas = [
    takeLatest(fetchList$2.type, onFetchAddressBook),
    takeLatest(addAddress.type, onAddAddress),
    takeLatest(deleteAddress.type, onDeleteAddress),
    takeLatest(editAddressSave.type, onEditAddress), 
];

const getUserId = (authState)=>authState.userId.split('|')[1] // id in format <proivder>|<auth0id>
;
function createUser(authState, hideUserData) {
    if (State.isUninitialized(authState)) {
        throw new Error('Can not build meaningful user data when unintialized');
    }
    if (State.isLoggedIn(authState)) {
        const id = hideUserData ? {
            auth0: '',
            auth0_email: ''
        } : {
            auth0: getUserId(authState),
            auth0_email: authState.email
        };
        return {
            id,
            loginStatus: true
        };
    } else {
        return {
            id: {
                auth0: '',
                auth0_email: ''
            },
            loginStatus: false
        };
    }
}
const clearEvents = ()=>{
    return DataLayer.Actions.pushEvent({
        events: null
    });
};

const mapAppointmentsForDataLayer = (a)=>{
    var ref, ref1;
    return {
        appointmentId: a.id,
        appointmentType: ((ref = a.appointmentType) === null || ref === void 0 ? void 0 : ref.name) || '',
        appointmentDate: format(a.startTime, 'ddMMyyyy'),
        appointmentTime: format(a.startTime, 'HH:mm'),
        storeName: ((ref1 = a.store) === null || ref1 === void 0 ? void 0 : ref1.name) || ''
    };
};
function* onAppointmentsView(action) {
    const evt = {
        event: 'myAccount',
        events: {
            category: 'my appointments',
            action: {
                block: 'appointment',
                interaction: 'view',
                appointments: action.payload.appointments.map(mapAppointmentsForDataLayer)
            }
        }
    };
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(evt));
}
function* onGenericAppointmentAction(actionType, action) {
    const evt = {
        event: 'myAccount',
        events: {
            category: 'my appointments',
            action: swcHelpers.objectSpread({
                block: 'appointment',
                interaction: actionType
            }, mapAppointmentsForDataLayer(action.payload.appointment))
        }
    };
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(evt));
}
/**
 * Main export
 */ var AppointmentsSagas = [
    takeLatest(APPOINTMENTS_VIEW, onAppointmentsView),
    takeLatest(UPCOMING_APPOINTMENT_VIEW, onGenericAppointmentAction, 'view'),
    takeLatest(RESCHEDULE_APPOINTMENT, onGenericAppointmentAction, 'reschedule'), 
];

const DOWNLOAD_PRESCRIPTION = 'my-account/datalayer/download-prescription';
const downloadPrescription = ()=>({
        type: DOWNLOAD_PRESCRIPTION
    })
;

function* onDownloadPrescription() {
    const evt = {
        event: 'myAccount',
        events: {
            category: 'my prescriptions',
            action: {
                block: 'prescriptions',
                interaction: 'download'
            }
        }
    };
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(evt));
}
/**
 * Main export
 */ var PrescriptionsSagas = [
    takeLatest(DOWNLOAD_PRESCRIPTION, onDownloadPrescription)
];

function* onOrderDetailsView(action) {
    const { orderId , orderDate , paymentStatus , shippingStatus  } = action.payload;
    if (!orderId || !orderDate) {
        throw new Error('Can not construct a meaningful event');
    }
    const data = makeOrderEvent('order details', 'view', orderId, orderDate, paymentStatus, shippingStatus);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onTraceOrder(action) {
    const { orderId , orderDate , paymentStatus , shippingStatus  } = action.payload;
    if (!orderId || !orderDate) {
        throw new Error('Can not construct a meaningful event');
    }
    const data = makeOrderEvent('product list', 'follow order', orderId, orderDate, paymentStatus, shippingStatus);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onOrderItemSelect(action) {
    const { select , orderId , orderDate , paymentStatus , shippingStatus  } = action.payload;
    if (!orderId || !orderDate) {
        throw new Error('Can not construct a meaningful event');
    }
    const data = makeOrderEvent('product list', select ? 'select' : 'unselect', orderId, orderDate, paymentStatus, shippingStatus);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onReorder(action) {
    const { currencyCode , id , lineItems  } = action.payload;
    if (!currencyCode || !id || !lineItems || lineItems.length === 0) {
        throw new Error('Can not construct a meaningful event');
    }
    yield put(DataLayer.Actions.pushEvent({
        atfEcommerce: null
    }));
    const data = makeReorderEvent(currencyCode, id, lineItems);
    yield put(DataLayer.Actions.pushEvent(data));
}
function makeReorderEvent(currencyCode, id, lineItems, prescriptionGlassesLineItems) {
    const products = DataLayer.DataLayerUtils.mapLineItemToDataLayerProductObjects(lineItems, prescriptionGlassesLineItems).map((product)=>swcHelpers.objectSpread({}, product, {
            dimension150: 'reorder: partial',
            dimension140: product ? product.id : 'n/a'
        })
    );
    return {
        event: 'gvAddToCart',
        atfEcommerce: {
            ecommerce: {
                currencyCode,
                cart: {
                    id
                },
                add: {
                    products
                }
            }
        }
    };
}
function makeOrderEvent(block, interaction, orderId, orderDate, paymentStatus, shippingStatus) {
    return {
        event: 'myAccount',
        events: {
            category: 'my orders',
            action: {
                block,
                interaction,
                orderId,
                orderDate: `${format(orderDate, `ddMMyyyy`)}`,
                paymentStatus: paymentStatus || 'n/a',
                shippingStatus: shippingStatus || 'n/a'
            }
        }
    };
}
/**
 * Main export
 */ var OrderSagas = [
    takeLatest(ORDER_DETAILS_VIEW, onOrderDetailsView),
    takeLatest(TRACE_ORDER, onTraceOrder),
    takeLatest(ORDER_ITEM_SELECT, onOrderItemSelect),
    takeLatest(ORDER_REORDER, onReorder), 
];

function* onPageView(action) {
    const auth = yield select(Selectors.getAuth);
    // can't do anything meaningful without auth data
    if (State.isUninitialized(auth)) {
        return;
    }
    const data = makePageView(auth, action.payload);
    yield put(DataLayer.Actions.pushEvent(data));
}
function makePageView(authState, payload) {
    const { currentRoute , hideUserData  } = payload;
    return {
        event: 'user_data_loaded',
        page: {
            type: `account - ${currentRoute}`
        },
        user: createUser(authState, hideUserData)
    };
}
/**
 * Main export
 */ var PageViewSagas = [
    takeLatest(PAGE_VIEW, onPageView)
];

function* onPasswordChangeSuccess() {
    const data = makePasswordChange('success');
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onPasswordChangeError(action) {
    const { error  } = action;
    const data = makePasswordChange('error', makeDescriptiveErrorMessage(error));
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function makeDescriptiveErrorMessage(error) {
    if (typeof error === 'string') {
        return error;
    }
    return `${error ? error.statusCode : ''}`;
}
function makePasswordChange(status, errorCode) {
    return {
        event: 'myAccount',
        events: {
            category: 'my profile',
            action: swcHelpers.objectSpread({
                block: 'password change',
                interaction: 'edit',
                status
            }, errorCode && {
                errorCode
            })
        }
    };
}
/**
 * Main export
 */ var PasswordChangeSagas = [
    takeLatest(Actions.ResetPasswordActions.CHANGE_PASSWORD_SUCCESS, onPasswordChangeSuccess),
    takeLatest(Actions.ResetPasswordActions.CHANGE_PASSWORD_FAILED, onPasswordChangeError), 
];

function* onProfileEditSuccess() {
    const data = makeProfileEdit('success');
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onProfileEditError(action) {
    const { error ={
        message: 'error'
    }  } = action.payload;
    const data = makeProfileEdit(error.message);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function makeProfileEdit(status) {
    return {
        event: 'myAccount',
        events: {
            category: 'my profile',
            action: {
                block: 'personal details',
                interaction: 'edit',
                status
            }
        }
    };
}
/**
 * Main export
 */ var MyProfileSagas = [
    takeLatest(PROFILE_EDIT_SUCCESS, onProfileEditSuccess),
    takeLatest(PROFILE_EDIT_ERROR, onProfileEditError), 
];

var dataLayerSagas = [
    ...PageViewSagas,
    ...MyProfileSagas,
    ...PasswordChangeSagas,
    ...OrderSagas,
    ...AppointmentsSagas,
    ...PrescriptionsSagas, 
];

function getStoreResult(apiConfig, storeId) {
    if (!apiConfig || !storeId) {
        return;
    }
    /**
   * We want to still show the prescription (without store name if this call fails. So we catch the error and don't
   * extend the prescription with store detail data, but don't send the use into a different flow.
   */ return Stores.getDetailsByCode(apiConfig.storesUrl, {
        code: storeId
    }).catch(console.error);
}
function* onFetchList$1() {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(fetchListFailed$1(new Error(`Can't fetch prescriptions when user isn't logged-in`)));
        return;
    }
    try {
        const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
        if (!apiConfig) {
            yield put(fetchListFailed$1({
                message: `Can't fetch stores without API Config`
            }));
            return;
        }
        const token = yield call(getToken);
        const response = yield call(Customers.Prescriptions.list, auth.apiUrl, token, {
            customerId: auth.userId
        });
        // Build store fetch call effects
        const storeFetchResults = response.reduce((m, prescription)=>{
            if (!prescription.storeId) {
                return m;
            }
            return swcHelpers.objectSpread({}, m, {
                [prescription.storeId]: call(getStoreResult, apiConfig, prescription.storeId)
            });
        }, {});
        const storeResponse = yield all(storeFetchResults);
        // Add store name to prescription
        const result = response.map((prescription)=>{
            var ref;
            return swcHelpers.objectSpread({}, prescription, {
                storeName: prescription.storeId && ((ref = storeResponse[prescription.storeId]) === null || ref === void 0 ? void 0 : ref.storeName)
            });
        });
        yield put(fetchListSuccess$1(result));
    } catch (err) {
        yield put(fetchListFailed$1(swcHelpers.objectSpread({}, err)));
    }
}
function* onFetchSigned() {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(fetchSignedFailed(new Error(`Can't fetch signed prescriptions when user isn't logged-in`)));
        return;
    }
    try {
        const token = yield call(getToken);
        const response = yield call(Customers.Prescriptions.signedPrescriptions, auth.apiUrl, token, {
            customerId: auth.userId
        });
        yield put(fetchSignedSucccess(response.prescriptionTokens));
    } catch (err) {
        yield put(fetchSignedFailed(swcHelpers.objectSpread({}, err)));
    }
}
var prescriptionsSagas = [
    takeLatest(FETCH_LIST$1, onFetchList$1),
    takeLatest(FETCH_SIGNED, onFetchSigned), 
];

function* submitUserForm(action) {
    const formName = action.payload;
    const auth = yield select(Selectors.getAuth);
    const userData = yield select(Selectors.getUserData);
    const formData = yield select(getFormData);
    if (!State.isLoggedIn(auth)) {
        throw new Error(`Can't fetch user data when not logged in`);
    }
    if (userData && statusSuccess(userData)) {
        yield put(Actions.UserDataActions.updateUserData({
            formName,
            formData: formData[formName]
        }));
    }
}
function* updateForm(action) {
    const formData = yield select(getForms) || {};
    const formNames = Object.keys(Types.FormName);
    const serverData = action.type === Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS ? action.payload.server : action.payload;
    const newFormsState = formNames.reduce((formAcc, formName)=>{
        const form = formData[formName];
        const clientForm = form && form.state || {
            formValid: false,
            formName,
            formState: {}
        };
        const serverForm = serverData[formName];
        if (!serverForm) {
            return formAcc;
        }
        const clientFieldNames = Object.keys(clientForm.formState);
        const serverFieldNames = Object.keys(serverForm);
        const combinedFieldNames = Array.from(new Set([
            ...clientFieldNames,
            ...serverFieldNames
        ]));
        const newFieldValues = combinedFieldNames.reduce((fieldAcc, fieldName)=>{
            const clientFieldState = clientForm.formState[fieldName] || {
                name: fieldName,
                value: ''
            };
            const serverValue = serverForm[fieldName];
            const value = serverValue ? serverValue.toString() : clientFieldState.value;
            return swcHelpers.objectSpread({}, fieldAcc, {
                [fieldName]: swcHelpers.objectSpread({}, clientFieldState, {
                    value
                })
            });
        }, {});
        return swcHelpers.objectSpread({}, formAcc, {
            [formName]: swcHelpers.objectSpread({}, clientForm, {
                formState: newFieldValues
            })
        });
    }, {});
    if (newFormsState.personalDetails) {
        yield put(changeFormValue({
            form: newFormsState.personalDetails
        }));
    }
    if (newFormsState.billingAddress) {
        yield put(changeFormValue({
            form: newFormsState.billingAddress
        }));
    }
    if (newFormsState.preferredStore) {
        yield put(changeFormValue({
            form: newFormsState.preferredStore
        }));
    }
}
function* userFormSuccess() {
    yield put(profileEditSuccess());
}
function* userFormFailed(action) {
    const { error  } = action.payload;
    yield put(profileEditError(error));
}
var profileSagas = [
    takeLatest(SUBMIT_USER_FORM, submitUserForm),
    takeLatest(Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS, userFormSuccess),
    takeLatest(Actions.UserDataActions.UPDATE_USER_DATA_FAILED, userFormFailed),
    takeLatest([
        Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS,
        Actions.UserDataActions.FETCH_USER_DATA_SUCCESS, 
    ], updateForm), 
];

const createProductLookup = (productProjections)=>{
    let product = {};
    let variant = {};
    productProjections.forEach((p)=>{
        const variants = [
            p.masterVariant,
            ...p.variants
        ];
        variants.forEach((v)=>{
            if (v.sku) {
                product = swcHelpers.objectSpread({}, product, {
                    [v.sku]: p
                });
                variant = swcHelpers.objectSpread({}, variant, {
                    [v.sku]: v
                });
            }
        });
    });
    return {
        product,
        variant
    };
};

const getSubscriptions = createSelector(getMyAccount, Selectors.getAuth, (myAccount, auth)=>State.isLoggedIn(auth) ? myAccount.subscriptions : undefined
);
const getSubscriptionDetail = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.detail : undefined
);
const getSubscriptionForm = createSelector(getSubscriptions, (subscription)=>{
    return subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionForm;
});
const getSubscriptionDetailCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.detailCall : idleState()
);
const getPauseCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.pauseCall : idleState()
);
const getQuantityCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.quantityCall : idleState()
);
const getProductDataCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.productDataCall : idleState()
);
const getProductData = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.productData : {}
);
const getSubscriptionList = createSelector(getSubscriptions, (subscriptions)=>subscriptions ? subscriptions.list : uninitState()
);

function* onDetailFetch(action) {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(fetchDetailFailed(new Error(`Can't fetch subscription details when user isn't logged-in`)));
        return;
    }
    try {
        const token = yield call(getToken);
        const response = yield call(Customers.Subscriptions.details, auth.apiUrl, token, {
            customerId: auth.userId,
            subscriptionId: action.payload.subscriptionId
        });
        yield put(fetchDetailSuccess(response));
        const productIds = response.lineItems.map((i)=>i.productId
        );
        yield put(fetchProductData({
            productIds
        }));
    } catch (err) {
        yield put(fetchDetailFailed(swcHelpers.objectSpread({}, err)));
    }
}
function* onPause(action) {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(pauseFailed(new Error(`Can't update subscription pausing state when user isn't logged-in`)));
        return;
    }
    const detail = yield select(getSubscriptionDetail);
    if (detail) {
        try {
            const token = yield call(getToken);
            yield call(Customers.Subscriptions.pause, auth.apiUrl, token, auth.userId, detail.id, action.payload);
            yield put(pauseSuccess({
                subscriptionId: detail.id
            }));
        } catch (err) {
            yield put(pauseFailed(swcHelpers.objectSpread({}, err)));
        }
    }
}
function* onPauseSuccess(action) {
    const { subscriptionId  } = action.payload;
    yield put(fetchDetail({
        subscriptionId
    }));
    yield call(toast.success, 'account.subscription.pause.success.toast');
}
function* onQuantity(action) {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(quantityFailed(new Error(`Can't update subscription quantity when user isn't logged-in`)));
        return;
    }
    const detail = yield select(getSubscriptionDetail);
    if (detail) {
        const { quantity  } = action.payload;
        const subscriptionQuantity = detail.lineItems.reduce((q, i)=>i.quantity
        , 0);
        if (quantity === subscriptionQuantity) {
            yield put(quantityFailed({
                reason: 'quantity_same'
            }));
            return;
        }
        try {
            const token = yield call(getToken);
            yield call(Customers.Subscriptions.quantity, auth.apiUrl, token, auth.userId, detail.id, action.payload);
            yield put(quantitySuccess({
                subscriptionId: detail.id
            }));
        } catch (err) {
            yield put(quantityFailed(swcHelpers.objectSpread({}, err)));
        }
    }
}
function* onQuantitySuccess(action) {
    const { subscriptionId  } = action.payload;
    yield put(fetchDetail({
        subscriptionId
    }));
    yield call(toast.success, 'account.subscription.quantity.success.toast');
}
function* onQuantityFailed(action) {
    if ('reason' in action.payload) {
        yield call(toast.info, 'account.subscription.quantity.noChange');
    }
}
function* onFetchProductData(action) {
    const { productIds  } = action.payload;
    const locale = yield select(IntlSelectors.getLocale);
    const auth = yield select(Selectors.getAuth);
    try {
        const { results  } = yield call(Products.query, `${auth.apiUrl}/products`, {
            filters: [
                `variants.sku:${encodeURIComponent(productIds.map((id)=>`"${id}"`
                ).join(','))}`
            ],
            expand: [
                'productType'
            ]
        });
        if (!results || !results.length) {
            const productData = productIds.reduce((acc, id)=>swcHelpers.objectSpread({}, acc, {
                    [id]: failedState(new Error('Did not receive any product data for this product'))
                })
            , {});
            yield put(fetchProductDataFailed({
                error: new Error(`Did not receive any product data for these IDs: ${productIds.join(', ')}`),
                productData
            }));
        }
        const lookup = createProductLookup(results);
        let succeeded = {};
        let failed = {};
        productIds.forEach((id)=>{
            const product = lookup.product[id];
            const variant = lookup.variant[id];
            if (!product || !variant) {
                failed = swcHelpers.objectSpread({}, failed, {
                    [id]: failedState(new Error(`No data was returned for variant with ID ${id}`))
                });
                return;
            }
            const productTypeName = Helpers.getProductTypeName(product);
            if (!productTypeName) {
                failed = swcHelpers.objectSpread({}, failed, {
                    [id]: failedState(new Error(`Couldn't find productType from product with ID ${product.id} for SKU ${id}`))
                });
            }
            if (id in lookup.product && id in lookup.variant && productTypeName) {
                const info = Helpers.getVariantInfo(product, productTypeName, locale || 'en-IE', variant);
                succeeded = swcHelpers.objectSpread({}, succeeded, {
                    [id]: successState(info)
                });
            } else {
                failed = swcHelpers.objectSpread({}, failed, {
                    [id]: failedState(new Error(`No data was returned for variant with ID ${id}`))
                });
            }
        });
        if (Object.keys(succeeded).length > 0) {
            yield put(fetchProductDataSuccess({
                productData: succeeded
            }));
        }
        if (Object.keys(failed).length > 0) {
            const error = new Error(`Encountered errors for variants with the following IDs: ${Object.keys(failed).join(', ')}`);
            yield put(fetchProductDataFailed({
                error,
                productData: failed
            }));
        }
    } catch (error) {
        const productData = productIds.reduce((acc, id)=>({
                [id]: failedState(new Error(`Encountered an error when fetching data. Error: ${error}`))
            })
        , {});
        yield put(fetchProductDataFailed({
            error,
            productData
        }));
    }
}
function* onFetchList() {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(fetchListFailed(new Error(`Can't fetch subscription list when user isn't logged-in`)));
        return;
    }
    try {
        const accessToken = yield call(getToken);
        const result = yield call(Customers.Subscriptions.list, auth.apiUrl, {
            customerId: auth.userId,
            accessToken
        });
        yield put(fetchListSuccess(result.subscriptions));
    } catch (err) {
        yield put(fetchListFailed(err));
    }
}
function* onSaveSubscriptionAddress(action) {
    const auth = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(auth)) {
        yield put(saveSubscriptionAddressFailed(new Error(`Can't update subscription address when user isn't logged-in`)));
        return;
    }
    try {
        const accessToken = yield call(getToken);
        const { custom  } = yield select(getSubscriptionDetail);
        yield call(Customers.changeAddress, auth.apiUrl, accessToken, auth.userId, {
            fields: Util.getValuesFromState(action.payload),
            externalId: custom === null || custom === void 0 ? void 0 : custom.membershipId,
            addressTypes: [
                'delivery-subscription'
            ]
        });
        yield put(saveSubscriptionAddressSuccess());
    } catch (err) {
        yield put(saveSubscriptionAddressFailed(err));
    }
}
var subscriptionsSagas = [
    takeLatest(FETCH_DETAIL, onDetailFetch),
    takeLatest(PAUSE, onPause),
    takeLatest(PAUSE_SUCCESS, onPauseSuccess),
    takeLatest(QUANTITY, onQuantity),
    takeLatest(QUANTITY_FAILED, onQuantityFailed),
    takeLatest(QUANTITY_SUCCESS, onQuantitySuccess),
    takeLatest(FETCH_PRODUCT_DATA, onFetchProductData),
    takeLatest(FETCH_LIST, onFetchList),
    takeLatest(SUBSCRIPTION_ADDRESS_SAVE, onSaveSubscriptionAddress), 
];

function* onUnlinkOrder(action) {
    const auth = yield select(Selectors.getAuth);
    const formattedRoutes = yield select(Selectors.getFormattedRoutes);
    const getSuccessRoute = (orderNumber)=>{
        return (formattedRoutes === null || formattedRoutes === void 0 ? void 0 : formattedRoutes.unlinkOrder) ? `${formattedRoutes.unlinkOrder}/success?orderNumber=${orderNumber}` : `unlink-order/success?orderNumber=${orderNumber}`;
    };
    try {
        const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
        if (!apiConfig) {
            yield put(unlinkOrderFailed(new Error('ApiConfig is unreachable')));
            return;
        }
        const { orderNumber , orderToken  } = action.payload;
        const requestBody = {
            orderNumber,
            orderToken
        };
        yield call(Orders$1.unlink, auth.apiUrl, requestBody);
        yield put(unlinkOrderSuccess());
        yield put(Actions.goto({
            path: getSuccessRoute(orderNumber)
        }));
    } catch (err) {
        yield put(unlinkOrderFailed(swcHelpers.objectSpread({}, err)));
    }
}
var unlinkOrderSagas = [
    takeLatest(unlinkOrder.type, onUnlinkOrder)
];

function* onCreateOrder(action) {
    let auth = yield select(Selectors.getAuth);
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    if (!apiConfig) {
        throw new Error('Need API configuration to create order.');
    }
    // Firstly, we might need to recover the session
    if (State.isInitialized(auth)) {
        yield put(Actions.LoginActions.recoverSession());
        const { loggedIn  } = yield race({
            loggedIn: take(Actions.LoginActions.PARSE_HASH_SUCCEEDED),
            loginFailed: take(Actions.LoginActions.RECOVER_SESSION_FAILED)
        });
        if (loggedIn) {
            auth = yield select(Selectors.getAuth);
        }
    }
    if (!State.isLoggedIn(auth)) {
        yield put(createOrderFailed(new Error(`Can only create order on behalf of user when they're actually logged-in`)));
        return;
    }
    try {
        const token = yield call(getToken);
        const result = yield call(Orders$1.createForCustomer, apiConfig.ordersUrl, auth.userId, token, action.payload);
        yield put(createOrderSuccess(result));
    } catch (err) {
        yield put(createOrderFailed(err));
    }
}
function* sagas() {
    yield all([
        ...addressBookSagas,
        ...dataLayerSagas,
        ...subscriptionsSagas,
        ...prescriptionsSagas,
        ...profileSagas,
        ...unlinkOrderSagas,
        takeLatest(CREATE_ORDER, onCreateOrder), 
    ]);
}

var PrescriptionSide;
(function(PrescriptionSide) {
    PrescriptionSide["Right"] = 'rightEye';
    PrescriptionSide["Left"] = 'leftEye';
})(PrescriptionSide || (PrescriptionSide = {}));
var PrescriptionKey;
(function(PrescriptionKey) {
    PrescriptionKey["Power"] = 'power';
    PrescriptionKey["Axis"] = 'axis';
    PrescriptionKey["Cylinder"] = 'cylinder';
    PrescriptionKey["Addition"] = 'addition';
    PrescriptionKey["BaseCurve"] = 'baseCurve';
    PrescriptionKey["Diameter"] = 'diameter';
    PrescriptionKey["PupillaryDistance"] = 'pupillaryDistance';
    PrescriptionKey["Prism"] = 'prism';
})(PrescriptionKey || (PrescriptionKey = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get PrescriptionSide () { return PrescriptionSide; },
  get PrescriptionKey () { return PrescriptionKey; }
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddressBookUtils: index$1
});

const [SubscriptionInvoiceFormSlotsProvider, useSubscriptionInvoiceFormSlots] = createSlotsContext({
    displayName: 'SubscriptionInvoiceFormSlotsContext'
});

const [PersonalDetailsFormSlotsProvider, usePersonalDetailsFormSlots] = createSlotsContext({
    displayName: 'PersonalDetailsFormSlotsContext'
});

const [AddressFormSlotsProvider, useAddressFormSlotsContext] = createSlotsContext({
    displayName: 'AddressFormSlotsContext'
});

const [StoreAddressFormSlotsProvider, useStoreAddressFormSlotsContext] = createSlotsContext({
    displayName: 'StoreAddressFormSlotsContext'
});

const [PaymentDetailsFormSlotsProvider, usePaymentDetailsFormSlots] = createSlotsContext({
    displayName: 'PaymentDetailsFormSlotsContext'
});

const [PreferredStoreFormSlotsProvider, usePreferredStoreFormSlots] = createSlotsContext({
    displayName: 'PreferredStoreFormSlotsContext'
});

const [SubscriptionAddressFormSlotsProvider, useSubscriptionAddressFormSlots] = createSlotsContext({
    displayName: 'SubscriptionAddressFormSlotsContext'
});

const [AppointmentSummarySlotsProvider, useAppointmentSummarySlotsContext] = createSlotsContext({
    displayName: 'AppointmentSummarySlotsContext'
});

const AddAddress = ({ addressForm , onSubmit , className  })=>{
    const { getFormattedLabel  } = useIntl();
    const addCall = useSelector(getAddCall);
    const isAddCallLoading = statusLoading(addCall);
    const isAddCallFailed = statusFailed(addCall);
    const handleSubmit = React.useCallback((state)=>{
        const _ref = Util.getValuesFromState(state.formState), { firstName , lastName , streetName  } = _ref, rest = swcHelpers.objectWithoutProperties(_ref, [
            "firstName",
            "lastName",
            "streetName"
        ]);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(swcHelpers.objectSpread({
            firstName,
            lastName,
            streetName,
            addressTypes: []
        }, rest));
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isAddCallFailed && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        message: getFormattedLabel('checkout.addressBook.newAddress.error', {
            parseLink: true
        })
    }), /*#__PURE__*/ React.createElement(Form, {
        name: "add-address",
        "data-t": "add-address",
        onSubmit: handleSubmit,
        className: classnames('add-address', className)
    }, /*#__PURE__*/ React.createElement("fieldset", {
        disabled: isAddCallLoading,
        className: "add-address__fieldset",
        "data-t": "add-address__fieldset"
    }, addressForm)));
};

const useAddressBook = ()=>{
    const dispatch = useDispatch();
    const toggleModal$1 = (state)=>{
        dispatch(toggleModal(state));
    };
    const toggleAddressModal = (isOpen)=>{
        toggleModal$1({
            isOpen,
            viewMode: ViewMode.ADD
        });
    };
    const deleteAddress$1 = (id)=>{
        dispatch(deleteAddress(id));
    };
    const editAddress$1 = (id)=>{
        dispatch(editAddress(id));
    };
    const closeModal = ()=>{
        dispatch(toggleModal({
            isOpen: false
        }));
    };
    return {
        closeModal,
        toggleAddressModal,
        deleteAddress: deleteAddress$1,
        editAddress: editAddress$1
    };
};

const useAddressBookList = ({ skip  } = {})=>{
    const dispatch = useDispatch();
    const state = useAccount();
    const addressBook = useSelector(getAddressBookList);
    React.useEffect(()=>{
        if (!skip && !statusUnavailable(addressBook) && statusUninit(addressBook) && state === State.AuthState.LoggedIn) {
            dispatch(fetchList$2());
        }
    }, [
        skip,
        state,
        dispatch,
        addressBook
    ]);
    if (skip || state === State.AuthState.LoggedOut) {
        return unavailableState();
    }
    return addressBook;
};

const elementName = 'myaccount-page-with-menu';
var PageWithMenu = ({ backRouteLinkAttributes , routes , logout , children , authState ,  })=>{
    const isTabletLandscapeAndUp = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const isUserLoggedIn = State.isLoggedIn(authState);
    const { isAddressBookEnabled , isAABEnabled  } = useFeatureToggles();
    const menuItems = useMyAccountMenuItems({
        logout,
        routes,
        isUserLoggedIn,
        isAddressBookEnabled,
        isAabEnabled: isAABEnabled
    });
    const _ref = backRouteLinkAttributes !== null && backRouteLinkAttributes !== void 0 ? backRouteLinkAttributes : {}, { label  } = _ref, linkRest = swcHelpers.objectWithoutProperties(_ref, [
        "label"
    ]);
    return /*#__PURE__*/ React.createElement("article", {
        className: elementName
    }, routes && isTabletLandscapeAndUp && /*#__PURE__*/ React.createElement(SubMenuLinks, {
        items: menuItems
    }), /*#__PURE__*/ React.createElement("div", {
        className: `${elementName}__content`
    }, backRouteLinkAttributes ? /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({}, linkRest, {
        iconBefore: "chevron-left",
        className: elementName + '__back-link'
    }), label) : null, children));
};
const mapStateToProps$2 = (state)=>({
        authState: Selectors.getAuth(state),
        routes: Selectors.getFormattedRoutes(state)
    })
;
const dispatchProps = {
    logout: Actions.LogoutActions.logOut
};
var PageWithMenu$1 = connect(mapStateToProps$2, dispatchProps)(PageWithMenu);

class Protected extends React.Component {
    componentDidMount() {
        this.returnPath = window.location.pathname.replace('//', '/').replace(/^\//, '');
        if (State.isInitialized(this.props.auth)) {
            /**
       * If a page was rendered on the server and the user makes their initial landing in our application, we recover
       * their running Auth0 session. This is similar to "assertSession", but we're checking the session for a different reason.
       */ this.props.recoverSession();
        } else if (State.isLoggedOut(this.props.auth)) {
            this.redirectOut();
        } else {
            /**
       * When a user changes their password their Auth0 session ends, and they need to log in again before they can
       * make authenticated requests. When the user navigates to a protected page, we want to know if the user still has
       * a valid session. If they don't, they should be redirected out of my-account directly and any user data should
       * not be visible or accessible anymore.
       */ this.props.assertSession();
        }
    }
    render() {
        const { auth  } = this.props;
        if (State.isLoggedIn(auth)) {
            return this.props.children;
        }
        return /*#__PURE__*/ React.createElement(LoaderScreen, {
            height: 50
        });
    }
    componentDidUpdate() {
        if (State.isLoggedOut(this.props.auth)) {
            this.redirectOut();
        }
    }
    constructor(...args){
        super(...args);
        this.redirectOut = ()=>{
            const query = this.returnPath ? `returnPath=${encodeURIComponent(`/${this.returnPath}`)}` : undefined;
            this.props.goto({
                route: RouteKey.Login,
                query,
                fullPageRefresh: true
            });
        };
    }
}
const mapStateToProps$1 = (state)=>({
        auth: Selectors.getAuth(state)
    })
;
const mapDispatchToProps$1 = {
    goto: Actions.goto,
    recoverSession: Actions.LoginActions.recoverSession,
    assertSession: Actions.LoginActions.assertSession
};
var Protected$1 = connect(mapStateToProps$1, mapDispatchToProps$1)(Protected);

class OnlyOnClient extends (React.Component) {
    componentDidMount() {
        this.setState({
            onServer: false
        });
    }
    render() {
        return this.state.onServer ? this.props.serverContent : this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            onServer: true
        };
    }
}
OnlyOnClient.defaultProps = {
    serverContent: /*#__PURE__*/ React.createElement(LoaderScreen, {
        height: 50
    })
};

const LoadingData = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "60px",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "40%",
        height: "15px",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "25%",
        height: "15px",
        rx: "5",
        fill: "currentColor",
        y: "30"
    })));
};

/* Protected routes */ const AppointmentDetailContainer = /*#__PURE__*/ React.lazy(()=>import('./AppointmentDetailContainer-659170a2.js')
);
const AddressBookContainer = /*#__PURE__*/ React.lazy(()=>import('./AddressBookContainer-46e66321.js')
);
const Appointments = /*#__PURE__*/ React.lazy(()=>import('./Appointments-3216f738.js')
);
const ProfileContainer = /*#__PURE__*/ React.lazy(()=>import('./ProfileContainer-ca332976.js')
);
const Orders = /*#__PURE__*/ React.lazy(()=>import('./OrdersContainer-7e5f75b7.js')
);
const OrderDetail = /*#__PURE__*/ React.lazy(()=>import('./OrderDetailContainer-f5855f13.js')
);
const Prescriptions = /*#__PURE__*/ React.lazy(()=>import('./PrescriptionPage-42ea6b43.js')
);
const Settings = /*#__PURE__*/ React.lazy(()=>import('./SettingsContainer-22eeb2dc.js')
);
const SubscriptionList = /*#__PURE__*/ React.lazy(()=>import('./SubscriptionList-f31581cc.js')
);
const UnlinkOrderContainer = /*#__PURE__*/ React.lazy(()=>import('./UnlinkOrderContainer-b3c26268.js')
);
const SubscriptionDetail = /*#__PURE__*/ React.lazy(()=>import('./SubscriptionDetail-bf35e393.js')
);
const ChangePassword = /*#__PURE__*/ React.lazy(()=>import('./ChangePassword-7a126ae9.js')
);
const OptIns = /*#__PURE__*/ React.lazy(()=>import('./index-d174efa8.js')
);
const SignUp = /*#__PURE__*/ React.lazy(()=>import('@grandvisionhq/auth').then((module)=>{
        return {
            default: module.CreateAccount.SignUp
        };
    })
);
const CreateAccountSetPassword = /*#__PURE__*/ React.lazy(()=>import('@grandvisionhq/auth').then((module)=>{
        return {
            default: module.CreateAccount.SetPassword
        };
    })
);
const SubmitEmailAddress = /*#__PURE__*/ React.lazy(()=>import('@grandvisionhq/auth').then((module)=>{
        return {
            default: module.ResetPassword.SubmitEmailAddress
        };
    })
);
const SetPassword = /*#__PURE__*/ React.lazy(()=>import('@grandvisionhq/auth').then((module)=>{
        return {
            default: module.ResetPassword.SetPassword
        };
    })
);
const Verify = /*#__PURE__*/ React.lazy(()=>import('@grandvisionhq/auth').then((module)=>{
        return {
            default: module.ResetPassword.Verify
        };
    })
);
const Login = /*#__PURE__*/ React.lazy(()=>import('@grandvisionhq/auth').then((module)=>{
        return {
            default: module.Login
        };
    })
);
class MyAccountRoot extends (React.Component) {
    static getDerivedStateFromProps(props, state) {
        const reverseRouteLookup = props.routes ? Object.entries(props.routes).reduce((reverse, [name, route])=>swcHelpers.objectSpread({}, reverse, {
                [route.toLowerCase()]: name
            })
        , {}) : {};
        const stripTrailingSlash = window.location.pathname.replace(/\/?$/, '');
        const urlParts = stripTrailingSlash.split('/');
        const newRoute = urlParts === null || urlParts === void 0 ? void 0 : urlParts[2];
        if (!newRoute || !state.reverseRouteLookup) {
            return swcHelpers.objectSpread({}, state, {
                reverseRouteLookup
            });
        }
        if (newRoute in reverseRouteLookup) {
            const path = urlParts[3] ? `${newRoute}/${urlParts[3]}` : `${newRoute}`;
            /**
       * The hash is not passed into currentRoute via setState because it is used as
       * the key for renderSubroute and adding a hash breaks internal router mapping
       */ return swcHelpers.objectSpread({}, state, {
                reverseRouteLookup,
                currentRoute: path
            });
        }
        return swcHelpers.objectSpread({}, state, {
            reverseRouteLookup
        });
    }
    componentDidMount() {
        const { isHideUserDataFromAnalyticsEnabled  } = this.props;
        this.props.pageView(this.state.currentRoute, Boolean(isHideUserDataFromAnalyticsEnabled));
    }
    componentDidUpdate(prevProps, prevState) {
        var _routes;
        const topLevelRoutes = Object.values((_routes = this.props.routes) !== null && _routes !== void 0 ? _routes : {});
        const isRouteEqual = prevState.currentRoute === this.state.currentRoute;
        const { isHideUserDataFromAnalyticsEnabled  } = this.props;
        const hasValidAuthState = State.isLoggedIn(this.props.authState) || State.isLoggedOut(this.props.authState) || State.isLoggedInPasswordless(this.props.authState);
        var ref;
        const routeExists = topLevelRoutes.some((route)=>{
            var ref1;
            return (ref = (ref1 = this.state.currentRoute) === null || ref1 === void 0 ? void 0 : ref1.includes(route)) !== null && ref !== void 0 ? ref : false;
        });
        const shouldLogPageView = !isRouteEqual && hasValidAuthState && routeExists;
        if (shouldLogPageView) {
            this.props.pageView(this.state.currentRoute, Boolean(isHideUserDataFromAnalyticsEnabled));
        }
    }
    render() {
        const { authState , staticsUrl , isAddressBookEnabled =false  } = this.props;
        if (State.isUninitialized(authState)) {
            return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(Loader, null), this.state.currentRoute, {
                isProtected: false,
                center: true
            });
        }
        // We do not want to lowercase the appointmentId, in es-masvision + es-optica2000 we still use TimeGrip which might return appointmentIds with upper- and lowercase, which we need to keep to later fetch appointments
        const currentRoute = this.state.currentRoute.startsWith('appointments') ? this.state.currentRoute : this.state.currentRoute.toLowerCase();
        let query;
        if (currentRoute === 'callback' || currentRoute === 'logged-out') {
            return /*#__PURE__*/ React.createElement(Callback, {
                type: currentRoute,
                parseHash: this.props.parseHash,
                loggedOut: this.props.loggedOut
            });
        }
        // These are the standard routes
        switch(this.state.reverseRouteLookup[currentRoute]){
            case RouteKey.CreateAccount:
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(React.Suspense, {
                    fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "myaccount__form-wrapper"
                }, /*#__PURE__*/ React.createElement(CreateAccountSetPassword, {
                    consentItems: this.props.consentItems
                }))), this.state.currentRoute, {
                    isProtected: false,
                    center: true
                });
            case 'linkExpired':
                query = window ? QueryString.parse(window.location.search, true) : undefined;
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(ExpiredLink, {
                    targetAction: query === null || query === void 0 ? void 0 : query.targetAction
                }), this.state.currentRoute, {
                    isProtected: false,
                    center: true
                });
            case RouteKey.ResetPassword:
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(React.Suspense, {
                    fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "myaccount__form-wrapper"
                }, /*#__PURE__*/ React.createElement(SubmitEmailAddress, null))), this.state.currentRoute, {
                    isProtected: false,
                    center: true
                });
            case RouteKey.Verify:
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(React.Suspense, {
                    fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "myaccount__form-wrapper"
                }, /*#__PURE__*/ React.createElement(Verify, null))), this.state.currentRoute, {
                    isProtected: false,
                    center: true
                });
            case RouteKey.SetPassword:
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(React.Suspense, {
                    fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "myaccount__form-wrapper"
                }, /*#__PURE__*/ React.createElement(SetPassword, null))), this.state.currentRoute, {
                    isProtected: false,
                    center: true
                });
            case RouteKey.Signup:
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(React.Suspense, {
                    fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "myaccount__form-wrapper--double"
                }, /*#__PURE__*/ React.createElement(SignUp, null))), this.state.currentRoute, {
                    isProtected: false,
                    center: true
                });
            case RouteKey.Login:
                const { returnPath , error , email  } = window && QueryString.parse(window.location.search);
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(React.Suspense, {
                    fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "myaccount__form-wrapper--double"
                }, /*#__PURE__*/ React.createElement(Login, {
                    returnPath: returnPath ? encodeURIComponent(StringGuard.guard('returnPath', returnPath)) : undefined,
                    createAccountRichText: this.props.createAccountRichText,
                    error: error ? StringGuard.guard('error', error) : undefined,
                    email: email ? StringGuard.guard('email', email) : undefined
                }))), this.state.currentRoute, {
                    isProtected: false,
                    center: true
                });
            case RouteKey.Prescriptions:
                {
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.profile
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(Prescriptions, null))), this.state.currentRoute);
                }
            case RouteKey.Settings:
                {
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.profile
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(Settings, {
                        showOptInsLink: authState.optIns.length > 0
                    }))), this.state.currentRoute, {
                        isProtected: true
                    });
                }
            case RouteKey.Profile:
                return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, null, /*#__PURE__*/ React.createElement(React.Suspense, {
                    fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                }, /*#__PURE__*/ React.createElement(ProfileContainer, null))), this.state.currentRoute, {
                    isProtected: true
                });
            case RouteKey.AddressBook:
                if (isAddressBookEnabled) {
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.profile
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(AddressBookContainer, null))), this.state.currentRoute, {
                        isProtected: true
                    });
                } else {
                    const { formattedRoutes  } = this.props;
                    formattedRoutes && (window === null || window === void 0 ? void 0 : window.location.assign(formattedRoutes[RouteKey.Profile]));
                }
            case RouteKey.Appointments:
                {
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.profile
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(Appointments, null))), this.state.currentRoute, {
                        isProtected: true
                    });
                }
            case RouteKey.Orders:
                {
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.profile
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(Orders, null))), this.state.currentRoute, {
                        isProtected: true
                    });
                }
            case RouteKey.Subscriptions:
                {
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.profile
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(SubscriptionList, null))), this.state.currentRoute, {
                        isProtected: true
                    });
                }
            default:
                var ref, ref2;
                if (currentRoute && ((ref = this.props.routes) === null || ref === void 0 ? void 0 : ref.appointments) && currentRoute.startsWith(this.props.routes.appointments)) {
                    const [_rest, appointmentId] = currentRoute.split('/');
                    if (appointmentId) {
                        return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                            backRouteLinkAttributes: this.props.frameworkRoutingLinks.appointments
                        }, /*#__PURE__*/ React.createElement(React.Suspense, {
                            fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                        }, /*#__PURE__*/ React.createElement(AppointmentDetailContainer, {
                            appointmentId: appointmentId
                        }))), this.state.currentRoute, {
                            isProtected: true
                        });
                    }
                } else if (currentRoute && this.props.routes && this.props.routes.orders && currentRoute.startsWith(this.props.routes.orders)) {
                    // orderNumber is number but we don't parse it because it has leading 0's
                    const [, orderNumber] = /\/([0-9]+)\/?$/.exec(currentRoute) || [];
                    if (orderNumber) {
                        return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                            backRouteLinkAttributes: this.props.frameworkRoutingLinks.orders
                        }, /*#__PURE__*/ React.createElement(React.Suspense, {
                            fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                        }, /*#__PURE__*/ React.createElement(OrderDetail, {
                            orderNumber: orderNumber
                        }))), this.state.currentRoute, {
                            isProtected: true
                        });
                    }
                } else if (currentRoute && this.props.routes && this.props.routes.subscriptions && currentRoute.startsWith(this.props.routes.subscriptions)) {
                    /**
           * subscriptionId is a string that can have an uppercase ID, so need the
           * non-lowercase version of currentRoute here
           */ const [, subscriptionId] = /\/(\w+)\/?$/.exec(this.state.currentRoute) || [];
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.profile
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(SubscriptionDetail, {
                        staticsUrl: staticsUrl,
                        subscriptionId: subscriptionId
                    }))), this.state.currentRoute, {
                        isProtected: true
                    });
                } else if (currentRoute && ((ref2 = this.props.routes) === null || ref2 === void 0 ? void 0 : ref2.unlinkOrder) && currentRoute.startsWith(this.props.routes.unlinkOrder)) {
                    const isSuccessPage = currentRoute.includes('/success');
                    const query = window ? QueryString.parse(window.location.search) : undefined;
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement("div", {
                        className: "myaccount__form-wrapper"
                    }, /*#__PURE__*/ React.createElement(UnlinkOrderContainer, {
                        isSuccessPage: isSuccessPage,
                        orderToken: query && query.orderToken ? StringGuard.guard('query.orderToken', query.orderToken) : undefined,
                        orderNumber: query && query.orderNumber ? StringGuard.guard('query.orderNumber', query.orderNumber) : undefined
                    }))), this.state.currentRoute, {
                        isProtected: false,
                        center: true
                    });
                } else if (currentRoute && this.props.routes && currentRoute.startsWith(this.props.routes.settings) && currentRoute.includes('/communication-preferences')) {
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.settings
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(OptIns, null))), this.state.currentRoute, {
                        isProtected: true
                    });
                } else if (currentRoute && this.props.routes && currentRoute.startsWith(this.props.routes.settings) && currentRoute.includes('/change-password')) {
                    const { changePasswordResult  } = QueryString.parse(window.location.search);
                    return MyAccountRoot.renderSubroute(/*#__PURE__*/ React.createElement(PageWithMenu$1, {
                        backRouteLinkAttributes: this.props.frameworkRoutingLinks.settings
                    }, /*#__PURE__*/ React.createElement(React.Suspense, {
                        fallback: /*#__PURE__*/ React.createElement(LoadingData, null)
                    }, /*#__PURE__*/ React.createElement(ChangePassword, {
                        isSuccess: changePasswordResult === 'success'
                    }))), this.state.currentRoute, {
                        isProtected: true
                    });
                }
                break;
        }
        /**
     * Next.js seems to render a higher level route before it renders a lowe level route. E.g. when
     * rendering /pages/my-account/prescriptions.tsx, it renders pages/my-account/[...rest].tsx first.
     * Issue: https://github.com/vercel/next.js/issues/43209
     *
     * To minimize layout shift, we render a loading screen.
     */ // TODO: this is really a 404 but we can't return that here anymore
        return /*#__PURE__*/ React.createElement(PageLoader, null);
    }
    constructor(...args){
        super(...args);
        this.state = {
            reverseRouteLookup: {},
            currentRoute: this.props.initialRoute.replace(/\/$/, ''),
            pageViewDone: false
        };
    }
}
MyAccountRoot.renderSubroute = (component, currentRoute, options = {
    isProtected: true
})=>{
    const wrappedComponent = /*#__PURE__*/ React.createElement("div", {
        className: classnames('myaccount-root', {
            'myaccount-root--center': options.center
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "site-container"
    }, component));
    return options.isProtected ? /**
       * Changing the key on every route change will re-mount the Protected component, triggering
       * an assertion of the user's Auth0 session.
       */ /*#__PURE__*/ React.createElement(Protected$1, {
        key: currentRoute
    }, wrappedComponent) : wrappedComponent;
};
const mapStateToProps = (state)=>{
    return {
        authState: Selectors.getAuth(state),
        formattedRoutes: Selectors.getFormattedRoutes(state),
        routes: Selectors.getRoutes(state)
    };
};
const mapDispatchToProps = {
    signup: Actions.CreateAccountActions.signup,
    onResend: Actions.CreateAccountActions.signup,
    loginWithPassword: Actions.LoginActions.loginWithPassword,
    parseHash: Actions.LoginActions.parseHash,
    loggedOut: Actions.LogoutActions.loggedOut,
    pageView: pageView
};
const MyAccountRootConnected = connect(mapStateToProps, mapDispatchToProps)(withIntl(withFrameworkRouting(MyAccountRoot)));
const MyAccountRootConnectedClientOnly = (props)=>{
    return /*#__PURE__*/ React.createElement(OnlyOnClient, null, /*#__PURE__*/ React.createElement(MyAccountRootConnected, swcHelpers.extends({}, props)));
};
class MyAccountRootConnectedClientOnlyWithContext extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement(AuthContextConsumer, null, /*#__PURE__*/ React.createElement(MyAccountRootConnectedClientOnly, swcHelpers.extends({}, this.props)));
    }
}
function withFrameworkRouting(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithFrameworkRouting = (props)=>{
        const { getLabel  } = useIntl();
        const profile = useLink({
            route: 'me.profile'
        });
        const appointments = useLink({
            route: 'me.appointments'
        });
        const orders = useLink({
            route: 'me.orders'
        });
        const settings = useLink({
            route: 'me.settings'
        });
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props, {
            frameworkRoutingLinks: {
                profile: swcHelpers.objectSpread({}, profile, {
                    label: getLabel(`account.menu.${RouteKey.Profile}`)
                }),
                appointments: swcHelpers.objectSpread({}, appointments, {
                    label: getLabel(`account.menu.${RouteKey.Appointments}`)
                }),
                orders: swcHelpers.objectSpread({}, orders, {
                    label: getLabel(`account.menu.${RouteKey.Orders}`)
                }),
                settings: swcHelpers.objectSpread({}, settings, {
                    label: getLabel(`account.menu.${RouteKey.Settings}`)
                })
            }
        }));
    };
    WithFrameworkRouting.displayName = `WithFrameworkRouting(${wrappedName})`;
    return WithFrameworkRouting;
}
function PageLoader() {
    const { getLabel  } = useIntl();
    const profileLinkProps = useLink({
        route: 'me.profile'
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "myaccount-root myaccount-root--center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "site-container"
    }, /*#__PURE__*/ React.createElement(PageWithMenu$1, null, /*#__PURE__*/ React.createElement("div", {
        className: "myaccount__subpage-loader"
    }, /*#__PURE__*/ React.createElement(Loader, null), profileLinkProps && /*
               * In case the user somehow ends up on this loading page without
               * being redirected, we still offer them an option to recover.
               */ /*#__PURE__*/ React.createElement(Delayed, {
        delay: 5000
    }, /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({}, profileLinkProps, {
        caption: getLabel('account.menu.accountDetails')
    })))))));
}

const UNAVAILABLE = {
    status: 'unavailable'
};
function isDataUnavailable(state) {
    return state.status === 'unavailable';
}
function isDataLoading(state) {
    return state.status === LOADING;
}
function isDataSuccess(state) {
    return state.status === SUCCESS;
}
const fetchIfUninit = (props)=>{
    if (statusUninit(props.auth.userSettings.userDataState.userData)) {
        props.fetchUserData();
    }
};
const resourceToDataState = (resource, defaultState, extractSuccess)=>{
    if (statusSuccess(resource)) {
        return extractSuccess(resource);
    } else if (statusFailed(resource)) {
        return UNAVAILABLE;
    } else {
        return defaultState;
    }
};
function WithUserData(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    class Wrapper extends (React.Component) {
        componentDidMount() {
            const { auth  } = this.props;
            if (State.isInitialized(auth)) {
                this.props.recoverSession();
            }
            if (State.isLoggedIn(auth)) {
                fetchIfUninit(this.props);
            }
        }
        componentDidUpdate(prevProps) {
            if (State.isUninitialized(prevProps.auth) && State.isInitialized(this.props.auth)) {
                this.props.recoverSession();
            }
            if (State.isInitialized(prevProps.auth) && State.isLoggedIn(this.props.auth)) {
                fetchIfUninit(this.props);
            }
        }
        render() {
            const { auth  } = this.props;
            const { email  } = auth;
            let userData1 = loadingState();
            if (!State.isUninitialized(auth) && !State.isInitialized(auth)) {
                userData1 = UNAVAILABLE;
            }
            if (State.isLoggedIn(auth)) {
                userData1 = resourceToDataState(auth.userSettings.userDataState.userData, loadingState(), (userData)=>successState(swcHelpers.objectSpread({}, userData.result, {
                        email
                    }))
                );
            }
            return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, this.props, {
                userData: userData1
            }));
        }
    }
    Wrapper.displayName = `WithUserData(${wrappedName})`;
    const mapStateToProps = (state)=>({
            auth: Selectors.getAuth(state)
        })
    ;
    const ConnectedWrapper = connect(mapStateToProps, {
        recoverSession: Actions.LoginActions.recoverSession,
        fetchUserData: Actions.UserDataActions.fetchUserData
    })(Wrapper);
    return (props)=>props.isMyAccountEnabled ? /*#__PURE__*/ React.createElement(ConnectedWrapper, swcHelpers.extends({}, props)) : /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props, {
            userData: UNAVAILABLE
        }))
    ;
}

const RoutesContext = /*#__PURE__*/ React.createContext({});
var RoutesProvider = (_param)=>{
    var { children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    const { Provider  } = RoutesContext;
    return /*#__PURE__*/ React.createElement(Provider, {
        value: rest
    }, children);
};
const useRoutesContext = ()=>React.useContext(RoutesContext)
;

const [CancelAndReturnsModalContentSlotsProvider, useCancelAndReturnsModalContentSlot] = createSlotsContext({
    displayName: 'CancelAndReturnsModalContentSlot'
});

ReducersRegistry.register('myAccount', reducer);
SagaRegistry.register('myAccount', sagas);

export { setSubscriptionFormIsEditMode as $, PrescriptionKey as A, getMyAccount as B, fetchList$1 as C, downloadPrescription as D, getSubscriptionList as E, fetchList as F, getUnlinkOrderCall as G, unlinkOrder as H, unlinkOrderFailed as I, getPauseCall as J, getProductData as K, LoadingData as L, getProductDataCall as M, getQuantityCall as N, pause as O, PrescriptionSide as P, quantity as Q, useSubscriptionAddressFormSlots as R, usePaymentDetailsFormSlots as S, getSubscriptionDetailCall as T, getSubscriptionDetail as U, ViewMode as V, getSubscriptionForm as W, fetchDetail as X, updateSubscriptionAddress as Y, saveSubscriptionAddress as Z, resetSubscriptionAddress as _, useAddressFormSlotsContext as a, setSubscriptionFormIsModalOpen as a0, actions as a1, selectors$1 as a2, selectors as a3, types as a4, index as a5, CancelAndReturnsModalContent as a6, SubscriptionInvoiceFormSlotsProvider as a7, useSubscriptionInvoiceFormSlots as a8, PersonalDetailsFormSlotsProvider as a9, AddressFormSlotsProvider as aa, StoreAddressFormSlotsProvider as ab, PaymentDetailsFormSlotsProvider as ac, PreferredStoreFormSlotsProvider as ad, SubscriptionAddressFormSlotsProvider as ae, AppointmentSummarySlotsProvider as af, AddAddress as ag, MyAccountRootConnectedClientOnlyWithContext as ah, CancelAndReturnsModalContentSlotsProvider as ai, RoutesProvider as aj, UNAVAILABLE as ak, isDataUnavailable as al, isDataLoading as am, isDataSuccess as an, WithUserData as ao, getAddressBookListLength as b, addAddress as c, getEditCall as d, editAddressSave as e, getModalState as f, getAddCall as g, getEditedAddress as h, deleteAddressConfirm as i, useAddressBookList as j, useAddressBook as k, useAppointmentSummarySlotsContext as l, appointmentsView as m, usePreferredStoreFormSlots as n, upcomingAppointmentView as o, getBillingAddress as p, changeFormValue as q, rescheduleAppointment as r, getPersonalDetails as s, toggleFormEditMode as t, useRoutesContext as u, usePersonalDetailsFormSlots as v, useCancelAndReturnsModalContentSlot as w, useStoreAddressFormSlotsContext as x, orderDetailsView as y, traceOrder as z };
//# sourceMappingURL=index-e050b74b.js.map
